import { render, staticRenderFns } from "./ContactDropdown.vue?vue&type=template&id=c193756e"
import script from "./ContactDropdown.vue?vue&type=script&lang=js"
export * from "./ContactDropdown.vue?vue&type=script&lang=js"
import style0 from "./ContactDropdown.vue?vue&type=style&index=0&id=c193756e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
